/**
 * Badge primitive — shadcn-style, utilitarian (D-03).
 */
import * as React from 'react';

type Variant = 'default' | 'success' | 'warning' | 'danger' | 'info' | 'outline';

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: Variant;
  children?: React.ReactNode;
}

const variantClasses: Record<Variant, string> = {
  default: 'bg-bg-card text-text-muted border border-border',
  success: 'bg-success/20 text-success border border-success/40',
  warning: 'bg-warning/20 text-warning border border-warning/40',
  danger: 'bg-danger/20 text-danger border border-danger/40',
  info: 'bg-info/20 text-info border border-info/40',
  outline: 'bg-transparent text-text border border-border',
};

export function Badge({
  variant = 'default',
  className = '',
  children,
  ...props
}: BadgeProps) {
  return (
    <span
      {...props}
      className={[
        'inline-flex items-center px-1.5 py-0.5 text-xs font-medium rounded leading-none',
        variantClasses[variant],
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </span>
  );
}
